export default {
	CONNECTING: 0,
	AUTHENTICATED_AND_OPEN: 1,
	CLOSING: 2,
	CLOSED: 3,
	AUTHENTICATING: 4,
	AUTHENTICATION_REJECTED: 5,
}
